var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "example" } },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("div", { attrs: { id: "bar" } }, [
            _c("h1", [_vm._v(_vm._s(_vm.$t("mail.emailEditor")))]),
            _vm._v(" "),
            _c("button", { on: { click: _vm.saveDesign } }, [
              _vm._v(_vm._s(_vm.$t("message.save"))),
            ]),
          ]),
          _vm._v(" "),
          _c("EmailEditor", {
            ref: "emailEditor",
            on: { load: _vm.editorLoaded, ready: _vm.editorReady },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "testModal2",
          attrs: { title: "Template İsmi", centered: "" },
          on: {
            cancel: function () {
              return (_vm.isVisibleAddTemplateName = false)
            },
            ok: _vm.addName,
          },
          model: {
            value: _vm.isVisibleAddTemplateName,
            callback: function ($$v) {
              _vm.isVisibleAddTemplateName = $$v
            },
            expression: "isVisibleAddTemplateName",
          },
        },
        [
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.templateName,
                  expression: "templateName",
                },
              ],
              staticClass: "template-name",
              attrs: { placeholder: "template isimi..." },
              domProps: { value: _vm.templateName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.templateName = $event.target.value
                },
              },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }